import { render, staticRenderFns } from "./RUStatusSummaryTable.vue?vue&type=template&id=3d6b54d3&scoped=true"
import script from "./RUStatusSummaryTable.vue?vue&type=script&lang=js"
export * from "./RUStatusSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./RUStatusSummaryTable.vue?vue&type=style&index=0&id=3d6b54d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b54d3",
  null
  
)

export default component.exports